module.exports = __webpack_public_path__ + "img/exam_jan_2025_wcrf6um3.0c7e6b9e.jpg";